{
  "name": "liquid-lens",
  "doc": "A noise warp at a large scale with a hint of zoom: the frame behaves like a thick lens of water, the forms swell and slide. The SPIRO wave draws loops the lens then bends.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.008,
  "zoomexp": 1.0,
  "rot": 0.0,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0.018,
  "warpScale": 1.6,
  "warpSpeed": 0.45,
  "decay": 0.958,
  "invert": 0,
  "hueShift": 0.004,
  "darkenCenter": 0.15,
  "wave": "SPIRO",
  "waveColor": 0,
  "shapes": 1,
  "energy": [
    0.35,
    0.8
  ]
}